import Triangle from '../../assets/buttons/triangle.svg';
import Circle from '../../assets/buttons/circle.svg';
import Square from '../../assets/buttons/square.svg';
import X from '../../assets/buttons/x.svg';
import Up from '../../assets/buttons/up.svg';
import Down from '../../assets/buttons/down.svg';
import Left from '../../assets/buttons/left.svg';
import Right from '../../assets/buttons/right.svg';
import R1 from '../../assets/buttons/R1.svg';
import R2 from '../../assets/buttons/R2.svg';
import R3 from '../../assets/buttons/R3.svg';
// import R3Left from '../../assets/buttons/R3-left.svg';
import L1 from '../../assets/buttons/L1.svg';
import L2 from '../../assets/buttons/L2.svg';
import L3 from '../../assets/buttons/L3.svg';
import R3L3Right from '../../assets/buttons/R3L3-right.svg';
import R3L3Left from '../../assets/buttons/R3L3-left.svg';
import GButton from '../../assets/buttons/G-button.svg';
import HButton from '../../assets/buttons/H-button.svg';
import Timer from '../../assets/buttons/timer.svg';

export interface IField {
  fieldName: string;
  redCornerButton?: string;
  blueCornerButton?: string;
  redCornerKey?: string;
  blueCornerKey?: string;
}

interface OutcomeFields {
  [key: string]: IField[];
}

const standingAndFenceFields = [
  {
    fieldName: 'totalStrikes',
    redCornerButton: R1,
    blueCornerButton: L1,
    redCornerKey: 'r',
    blueCornerKey: 'u',
  },
  {
    fieldName: 'significantStrikesHead',
    redCornerButton: Up,
    blueCornerButton: Triangle,
    redCornerKey: 'e',
    blueCornerKey: 'i',
  },
  {
    fieldName: 'significantStrikesBody',
    redCornerButton: Right,
    blueCornerButton: Square,
    redCornerKey: 'w',
    blueCornerKey: 'o',
  },
  {
    fieldName: 'significantStrikesLegs',
    redCornerButton: Down,
    blueCornerButton: X,
    redCornerKey: 'q',
    blueCornerKey: 'p',
  },
  {
    fieldName: 'takedownAttempts',
    redCornerButton: Left,
    blueCornerButton: Circle,
    redCornerKey: 'f',
    blueCornerKey: 'j',
  },
  {
    fieldName: 'takedowns',
    redCornerButton: L2,
    blueCornerButton: R2,
    redCornerKey: 'd',
    blueCornerKey: 'k',
  },
  {
    fieldName: 'transitions',
    redCornerButton: R3L3Right,
    blueCornerButton: R3L3Left,
    redCornerKey: 'c',
    blueCornerKey: 'm',
  },
  {
    fieldName: 'submissionAttempts',
    redCornerButton: R3L3Left,
    blueCornerButton: R3L3Right,
    redCornerKey: 'a',
    blueCornerKey: 'n',
  },
  {
    fieldName: 'takedownsDefended',
    redCornerButton: L3,
    blueCornerButton: R3,
    redCornerKey: 's',
    blueCornerKey: 'l',
  },
  {
    fieldName: 'knockdowns',
    redCornerButton: GButton,
    blueCornerButton: HButton,
    redCornerKey: 'g',
    blueCornerKey: 'h',
  },
  {
    fieldName: 'significantStrikes',
  },
  {
    fieldName: 'elapsedControlTime',
    redCornerButton: Timer,
    blueCornerButton: Timer,
  },
];

const ground = [
  {
    fieldName: 'totalStrikes',
    redCornerButton: R1,
    blueCornerButton: L1,
    redCornerKey: 'r',
    blueCornerKey: 'u',
  },
  {
    fieldName: 'significantStrikesHead',
    redCornerButton: Up,
    blueCornerButton: Triangle,
    redCornerKey: 'e',
    blueCornerKey: 'i',
  },
  {
    fieldName: 'significantStrikesBody',
    redCornerButton: Right,
    blueCornerButton: Square,
    redCornerKey: 'w',
    blueCornerKey: 'o',
  },
  {
    fieldName: 'significantStrikesLegs',
    redCornerButton: Down,
    blueCornerButton: X,
    redCornerKey: 'q',
    blueCornerKey: 'p',
  },
  {
    fieldName: 'transitions',
    redCornerButton: R3L3Right,
    blueCornerButton: R3L3Left,
    redCornerKey: 'c',
    blueCornerKey: 'm',
  },
  {
    fieldName: 'submissionAttempts',
    redCornerButton: R3L3Left,
    blueCornerButton: R3L3Right,
    redCornerKey: 'a',
    blueCornerKey: 'n',
  },
  {
    fieldName: 'significantStrikes',
  },
  {
    fieldName: 'elapsedControlTime',
  },
];

const wrestling = [
  {
    fieldName: 'takedownAttempts',
    redCornerButton: 'f',
    blueCornerButton: 'j',
    redCornerKey: 'f',
    blueCornerKey: 'j',
  },
  {
    fieldName: 'takedowns',
    redCornerButton: 'd',
    blueCornerButton: 'k',
    redCornerKey: 'd',
    blueCornerKey: 'k',
  },
  {
    fieldName: 'escapes',
    redCornerButton: 'shift+e',
    blueCornerButton: 'shift+i',
    redCornerKey: 'shift+e',
    blueCornerKey: 'shift+i',
  },
  {
    fieldName: 'nearFalls',
    redCornerButton: 'r',
    blueCornerButton: 'u',
    redCornerKey: 'r',
    blueCornerKey: 'u',
  },
  {
    fieldName: 'exposures',
    redCornerButton: 's',
    blueCornerButton: 'l',
    redCornerKey: 's',
    blueCornerKey: 'l',
  },
  // {
  //   fieldName: 'pinnings',
  //   redCornerButton: 'a',
  //   blueCornerButton: 'n',
  //   redCornerKey: 'a',
  //   blueCornerKey: 'n',
  // },
  {
    fieldName: 'roles',
    redCornerButton: 'shift+w',
    blueCornerButton: 'shift+o',
    redCornerKey: 'shift+w',
    blueCornerKey: 'shift+o',
  },
  {
    fieldName: 'reversals',
    redCornerButton: 'g',
    blueCornerButton: 'h',
    redCornerKey: 'g',
    blueCornerKey: 'h',
  },
  // {
  //   fieldName: 'turnovers',
  //   redCornerButton: 'e',
  //   blueCornerButton: 'p',
  //   redCornerKey: 'e',
  //   blueCornerKey: 'p',
  // },
  // {
  //   fieldName: 'counterattacks',
  //   redCornerButton: 'w',
  //   blueCornerButton: 'o',
  //   redCornerKey: 'w',
  //   blueCornerKey: 'o',
  // },
  // {
  //   fieldName: 'stallings',
  //   redCornerButton: 'q',
  //   blueCornerButton: 'i',
  //   redCornerKey: 'q',
  //   blueCornerKey: 'i',
  // },
  // {
  //   fieldName: 'falls',
  //   redCornerButton: 'shift+r',
  //   blueCornerButton: 'shift+u',
  //   redCornerKey: 'shift+r',
  //   blueCornerKey: 'shift+u',
  // },
  {
    fieldName: 'outOfBounds',
    redCornerButton: 'shift+a',
    blueCornerButton: 'shift+n',
    redCornerKey: 'shift+a',
    blueCornerKey: 'shift+n',
  },
  {
    fieldName: 'passivities',
    redCornerButton: 'shift+c',
    blueCornerButton: 'shift+m',
    redCornerKey: 'shift+c',
    blueCornerKey: 'shift+m',
  },
  {
    fieldName: 'technicalViolations',
    redCornerButton: 'c',
    blueCornerButton: 'm',
    redCornerKey: 'c',
    blueCornerKey: 'm',
  },
  // {
  //   fieldName: 'cautions',
  //   redCornerButton: 'shift+g',
  //   blueCornerButton: 'shift+h',
  //   redCornerKey: 'shift+g',
  //   blueCornerKey: 'shift+h',
  // },
  // {
  //   fieldName: 'backtakes',
  //   redCornerButton: 'shift+d',
  //   blueCornerButton: 'shift+j',
  //   redCornerKey: 'shift+d',
  //   blueCornerKey: 'shift+j',
  // },
];

const grappling = [
  {
    fieldName: 'takedownAttempts',
    redCornerButton: Left,
    blueCornerButton: Circle,
    redCornerKey: 'f',
    blueCornerKey: 'j',
  },
  {
    fieldName: 'takedowns',
    redCornerButton: L2,
    blueCornerButton: R2,
    redCornerKey: 'd',
    blueCornerKey: 'k',
  },
  {
    fieldName: 'transitions',
    redCornerButton: R3L3Right,
    blueCornerButton: R3L3Left,
    redCornerKey: 'c',
    blueCornerKey: 'm',
  },
  {
    fieldName: 'submissionAttempts',
    redCornerButton: R3L3Left,
    blueCornerButton: R3L3Right,
    redCornerKey: 'a',
    blueCornerKey: 'n',
  },
  {
    fieldName: 'takedownsDefended',
    redCornerButton: L3,
    blueCornerButton: R3,
    redCornerKey: 's',
    blueCornerKey: 'l',
  },
  {
    fieldName: 'passivities',
    redCornerButton: Down,
    blueCornerButton: X,
    redCornerKey: 'q',
    blueCornerKey: 'p',
  },
  {
    fieldName: 'advantages',
    redCornerButton: Right,
    blueCornerButton: Square,
    redCornerKey: 'w',
    blueCornerKey: 'o',
  },
  {
    fieldName: 'elapsedControlTime',
    redCornerButton: Timer,
    blueCornerButton: Timer,
  },
];

export const fields: OutcomeFields = {
  standing: standingAndFenceFields,
  fence: standingAndFenceFields,
  ground,
};

export const fieldsWrestling: OutcomeFields = {
  standing: wrestling,
  riding: wrestling,
  ground: wrestling,
};

export const fieldsGrappling: OutcomeFields = {
  standing: grappling,
  riding: grappling,
  ground: grappling,
};
